module.exports = __webpack_public_path__ + "img/Frame 750.c6887c67.png";